export default __webpack_public_path__ + "static/media/Carta de conformacion de grupo.963d4167.docx";